import SearchQuery from '@vue-storefront/core/lib/search/searchQuery'

export function productQuery(uid) {
  let query: SearchQuery = new SearchQuery()
  let filters: any
  query = query.applyFilter({ key: 'url_key', value: { eq: uid } })
  return query
}
